<template>
  <div style=" width:100%; height: 100%;">

    <v-icon v-if="isMobile" color="primary" @click="changeRightPanelStatus(false)" size="28">mdi-arrow-left</v-icon>
    <h5 v-if="isMobile" style="display: inline; margin-left: 3%;">Additional info :</h5>
      <v-tabs v-model="tab" grow>
        <v-tab v-if="!labpagestatus" value="contactInfo"><v-icon size="30px" :color="tab=='contactInfo'?'blue':'secondary'">mdi-account-details</v-icon></v-tab>
        <v-tab value="internalConversations">
          <v-badge v-if="unreadMessages.length" :color="'#FB4141'" :content="unreadMessages.length">
            <v-icon size="30px" :color="tab=='internalConversations'?'green':'secondary'">mdi-chat</v-icon>
          </v-badge>
          <v-icon v-else size="30px" :color="tab=='internalConversations'?'green':'secondary'">mdi-chat</v-icon>
        </v-tab>
        <v-tab v-if="isODEnabled" value="appointments"><v-icon size="30px" :color="tab=='appointments'?'red':'secondary'">mdi-calendar-today</v-icon></v-tab>
       <v-tab v-if="getOdTag && getOdTag.tag_icon ==='flask'" value="lab-cases">
        <v-icon size="30px" :color="tab === 'lab-cases' ? 'purple' : 'secondary'">mdi-flask</v-icon>
      </v-tab>
          <v-tab v-if="!labpagestatus && getOdTag && getOdTag.tag_icon === 'clipboard-check-outline'"
             value="PreAuthsDetails" >
              <v-icon
                size="30px"
                :color="getOdTag.tag_icon === 'clipboard-check-outline'? '#9C27B0':'secondary'"
              > mdi-{{getOdTag.tag_icon}}
              </v-icon>
            </v-tab>
            <v-tab v-if="!labpagestatus && $route.path ==='/frontdesk'"
             value="uploadfileOD">
                    <v-icon
                size="30px"
                :color="tab=='uploadfileOD'?'primary':'secondary'"
              > mdi-folder-arrow-up
              </v-icon>
            </v-tab>
            <v-tab  v-if="!labpagestatus && getOdTag && getOdTag.tag_icon === 'help-box-multiple-outline'"
            value="pendingTreatmentDetails">
                <v-icon
                size="30px"
                :color="getOdTag.tag_icon === 'help-box-multiple-outline'? '#FFC107' :'secondary'"
              > mdi-{{getOdTag.tag_icon}}
              </v-icon>
            </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <div v-if="tab === 'contactInfo'" class="tab-container">
        <ContactDetails :contact="contact" />
      </div>

      <div v-if="tab === 'internalConversations'">
        <v-card
          v-if="showlabdata && labcasesdata.labcase_number && !loadingLabCase"
          class="pa-5 rounded-xl"
          elevation="3"
        >
          <v-row dense>
            <v-col cols="12" class="d-flex align-center">
          <!-- Primary icon  -->
          <template v-if="primaryField">
            <v-tooltip :text="`${primaryField.label}: ${displayDate(primaryField.value)}`" location="top">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" :color="primaryField.color" class="mr-2">
                  {{ primaryField.icon }}
                </v-icon>
              </template>
            </v-tooltip>
          </template>

          <!-- Expand-->
          <v-icon
            color="grey"
            class="ml-2"
            @click="showExtraDates = !showExtraDates"
            style="cursor: pointer;"
          >
            {{ showExtraDates ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
          </v-icon>

          <!-- other icons when expanded -->
          <template v-if="showExtraDates && otherDateFields.length">
            <div
              v-for="field in otherDateFields"
              :key="field.label"
              class="d-flex align-center ml-3"
            >
              <v-tooltip :text="`${field.label}: ${displayDate(field.value)}`" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" :color="field.color" class="mr-2">
                    {{ field.icon }}
                  </v-icon>
                </template>
              </v-tooltip>
            </div>
          </template>
        </v-col>


            <!-- Instructions -->
            <v-col cols="12" v-if="labcasesdata.instructions">
              <v-tooltip :text="`instructions:${labcasesdata.instructions}`">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="green" class="mr-2">mdi-clipboard-text</v-icon>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>

        <!-- Loading State -->
        <div v-else-if="loadingLabCase" class="displayCenter" style="padding: 10px;">
          <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
          <span style="margin-left: 8px;">Loading Lab Case...</span>
        </div>


        <div v-if="contact && contact.contact_id">
            <div v-if="local_internalConvos.length === 0 && convoListType === 'all' && selectedConvo == null">
              No Internal Convos Found.
            </div>
            <div v-else-if="local_internalConvos.length === 0 && selectedConvo == null">
              <p>No Internal Convos Found for that.</p>
              <div style="margin-top: 20px" class="displayCenter">
                <v-btn outlined @click="goBackToAll">
                  Go back to all convos
                </v-btn>
              </div>
            </div>
            <div v-else-if="selectedConvo == null" class="tab-container">
              <v-hover v-for="convo in local_internalConvos" :key="convo.convo_id">
                <div  @click="openConvo(convo)" style="display:flex;margin-bottom: 10px; border-radius: 5px; cursor: pointer;">
                  <v-tooltip v-if="convo.userMentioned > 0 && !convo.userReminder" location="top" text="You have an uncompleted task in this conversation with no reminder">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" dense color="primary">
                        mdi-rhombus-medium
                      </v-icon>
                    </template>
                  </v-tooltip>
                <div v-if="convo.convo_references && convo.convo_references.length">
                    <div
                      v-for="(reference, index) in convo.convo_references"
                      :key="reference.id || index"
                    >
                      <v-icon
                        v-if="reference.contact_id && !reference.conversation_id && !reference.LabCaseNum"
                        color="primary"
                      >
                        mdi-account
                      </v-icon>

                      <v-icon
                        v-else-if="reference.contact_id && reference.conversation_id"
                        color="green"
                      >
                        mdi-forum
                      </v-icon>

                      <v-icon
                        v-else-if="reference.contact_id && !reference.conversation_id && reference.LabCaseNum"
                        color="deep-purple"
                      >
                        mdi-flask
                      </v-icon>
                    </div>
                  </div>
                  <div style="padding: 5px" v-if="convo.unread">
                    <span class="text-h6" ><strong>{{ convo.convo_name }}</strong></span>
                  </div>
                  <div style="padding: 5px;" v-else>
                    <span class="text-h6" >{{ convo.convo_name }}</span>
                  </div>
                  <v-tooltip v-if="convo.userReminder" location="right" :text="dayjs(convo.userReminder.reminder_date).format('h:mmA M/D/YYYY')">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props" style="font-size: .7rem;">
                        {{ fromNow(convo.userReminder.reminder_date) }}
                        <v-icon dense color="#F93827">mdi-alarm</v-icon>
                      </div>
                    </template>
                  </v-tooltip>
                </div>
              </v-hover>
              <div v-if="convoListType !== 'all'"  class="displayCenter">
                <v-btn outlined @click="goBackToAll()">Go back to all convos</v-btn>
              </div>
            </div>
            <div v-else>
              <div style="display: flex">
                <div>
                  <v-icon @click="closeConvo()">mdi-arrow-left</v-icon>
                </div>
                <div style="width: 100%" class="displayCenter">
                  <v-tooltip location="top" text="Close this conversation" v-if="selectedConvo.owner == userId || isAdmin ">
                    <template v-slot:activator="{ props }">
                      <v-icon v-if="!value" v-bind="props" @click="deleteConvo(selectedConvo)" class="ml-2" color="red">mdi-close-octagon</v-icon>
                    </template>
                  </v-tooltip>
                  
                  <div v-if="selectedMessage" >
                    <FDMessage :message="selectedMessage" :active="false" :fullWidth="true" :contact="getHeaderInfo(selectedConversation.contact_id)" v-if="selectedMessage"></FDMessage>
                  </div>
                  <ContactPopup v-else :contact_id="contact.contact_id" :tooltip="false" />
                </div>
                <div class="displayCenter">
                  <div
                    v-if="selectedConvo.convo_participants && selectedConvo.convo_participants.length"
                    style="grid-area: 1/1/1/1; justify-self: end;"
                  >
                    <div
                      style="display: flex; flex-direction: row-reverse; flex-wrap: nowrap; justify-content: end; align-items: center;"
                    >
                      <div
                        v-for="participant in selectedConvo.convo_participants"
                        :key="participant.user_id || participant.contact_id"
                        style="flex: 1 1 1; margin-left: -8px;"
                      >
                        <template v-if="participant.user_id">
                          <UserPopup :user_id="participant.user_id" :badge="getReminder(participant.user_id) ? true : false">
                            <template v-slot:badge>
                              <v-tooltip location="top" :text="dayjs(getReminder(participant.user_id).reminder_date).format('h:mmA M/D/YYYY')">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props">mdi-alarm</v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </UserPopup>
                        </template>
                        <template v-else>
                          <ContactPopup :contact_id="participant.contact_id" :tooltip="false" />
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                 <div v-if="seeReference" class="ref-button">
                  <v-btn @click="getConversations" icon size="25" color="warning" variant ="outlined" class="heartbeat"><v-icon>mdi-hand-pointing-left</v-icon></v-btn>
                </div>
              <v-divider style="margin-top: 10px"/>
              <div style="width: 100%; height: 50vh;">
              <DynamicScroller
                :items="internalMessages"
                :minItemSize="internalMessages.length"
                key-field="convo_message_id"
                style="height: 100%; margin-top: 20px"
                :buffer="20000"
                ref="scroller"
              >
                <template v-slot="{ item, index, active}">
                  <DynamicScrollerItem :item="item" :active="active">
                    <Message :index="index" :prev="index === 0 ? null : internalMessages[index-1]" :active="active" :message="item"
                    :refrenceConvo="getReferenceMessage(item.ref, index)"  @reference-click="scrollToReference" />
                  </DynamicScrollerItem>
                </template>
              </DynamicScroller>
              </div>
              <div style="display: flex; width: 100%; padding-bottom: var(--safe-area-inset-bottom);">
              <ConvoBox 
                :convo="selectedConvo"
                @internalMessageSent="internalMessageSent($event)"
                @closeConvo="closeConvo()"
                @update="$forceUpdate()"
              />
            </div>
            </div>
          </div>
          <div v-else>
            Select a Contact to view internal conversations!
          </div>
            <div v-if="contact?.contact_id && convoListType === 'all' && selectedConvo == null" style="padding-bottom: var(--safe-area-inset-bottom);">
              <div :class="internal_convos.length ? '' : 'tab-container'"></div>
              <v-layout class="overflow-visible" style="height: 56px;">
                <v-bottom-navigation
                  v-model="value"
                  :color="value==0 ?'teal':'red'"
                  grow
                >
                  <v-btn @click="getOpenedConvos">
                    <v-icon color="green">mdi-check-circle</v-icon>
                  
                    Active Convo's
                  </v-btn>

                  <v-btn @click="getClosedConvos">
                    <v-icon color="red">mdi-close-octagon-outline</v-icon>
                  
                    Closed Convo's
                  </v-btn>
                </v-bottom-navigation>
              </v-layout>
            </div>
      </div>

      <div v-if="tab === 'appointments'"  class="tab-container">
        <AppointmentDetails :contact="contact" />
      </div>
      <div v-if="tab ==='lab-cases'" class="tab-container">
        <LabCasesDetails :contact="contact"/>
      </div>
      <div v-if="tab ==='PreAuthsDetails'" class="tab-container">
      <PreAuthsDetails :contact="contact"/>
    </div>
<div v-if="tab === 'uploadfileOD'" style="width:100%; height: 78vh; overflow:hidden;">
  <uploadfileOD :contact="contact" />
</div>

      <div v-if="tab === 'pendingTreatmentDetails'" class="tab-container">
        <pendingTreatmentDetails :contact="contact"/>
      </div>
      </div>
</template>

<script>
import ContactPopup from "@/components/Avatar/ContactPopup";
import UserPopup from "@/components/Avatar/UserPopup";
import Message from "@/components/Messenger/Message";
import ConvoBox from "@/components/FrontDesk/RightPanel/ConvoBox";
import EventBus from "@/eventBus";
import ConvoService from "@/services/convoService";
import odService from "../../../services/odService";
import MiscService from "@/services/miscService";
import dayjsMixin from "@/mixins/dayjsMixin";
import { mapGetters, mapActions,mapState, mapMutations } from "vuex";
import AppointmentDetails from './AppointmentDetails.vue';
import LabCasesDetails from './LabCasesDetails.vue'
import PreAuthsDetails from "./PreAuthsDetails.vue";
import uploadfileOD from "./uploadfileOD.vue";
import pendingTreatmentDetails from "./pendingTreatmentDetails.vue"
import ContactDetails from './ContactDetails.vue'
import FDMessage from "../FDMessage.vue";
export default {
  name: "RightPanel",
  mixins: [ dayjsMixin ],
  components: {
    Message,
    ConvoBox,
    ContactPopup,
    uploadfileOD,
    UserPopup,
    AppointmentDetails,
    ContactDetails,
    FDMessage,
    LabCasesDetails,
    PreAuthsDetails,
    pendingTreatmentDetails,
  },
  data() {
    return {
      tab : '',
      chatRef:[],
      contact: {
        contact_id: null,
        OD_PatNum: null,
      },
      selectedConvo: null,
      convoListType: 'all', // values 'all', 'contact', 'comm'
      internalMessages: [],
      convoHighlightTimeout: null,
      appointmentsList: [],  
      isfamily : false,
      value : 0,
      local_internalConvos : [],
      seeReference: false,
      selectedMessage: null,
      labcasesdata :{},
      loadingLabCase: false, 
      showlabdata:false,
      showExtraDates: false, 
    };
  },

  computed: {
    ...mapGetters(['isAdmin']),
    ...mapGetters('labcases', ['labpagestatus']),
    ...mapState(['isPanelVisible','contactState']),
    ...mapGetters(['userId',"isODEnabled"]),
    ...mapGetters("convos", ["contact_internal_convo", "internal_convos_on_contact", "internal_convos_on_comm","internal_convos"]),
    ...mapGetters("frontdesk",["right_panel_tab","getOdTag"]),
    ...mapGetters("window", ["isMobile"]),
     ...mapGetters("people",["getHeaderInfo"]),
    unreadMessages() {
      return this.local_internalConvos.filter((convo) => convo.unread);
    },
    selectedConversation(){
      return this.selectedConvo?.convo_references[0]?.conversation;
    },
 //  labcasesdata and filter out
  labDateFields() {
    const defs = {
      Created: { key: "date_created", icon: "mdi-file-plus-outline", color: "green" },
      Due: { key: "date_due", icon: "mdi-calendar-clock", color: "red" },
      Checked: { key: "date_checked", icon: "mdi-check-decagram", color: "blue" },
      Received: { key: "date_received", icon: "mdi-inbox-arrow-down", color: "purple" },
      Sent: { key: "date_sent", icon: "mdi-send-check", color: "orange" }
    };

    return Object.keys(defs).map(label => {
      const { key, icon, color } = defs[label];
      const value = this.labcasesdata ? this.labcasesdata[key] : null;
      return { label, key, value, icon, color };
    }).filter(f => this.isValidLabDate(f.value));
  },

  // primary the first valid field
  primaryField() {
    const created = this.labDateFields.find(f => f.label === "Created");
    if (created) return created;
    return this.labDateFields.length ? this.labDateFields[0] : null;
  },

  // fields show when expanded
  otherDateFields() {
    if (!this.primaryField) return this.labDateFields;
    return this.labDateFields.filter(f => f.label !== this.primaryField.label);
  }
  },
  mounted() {
    this.local_internalConvos = this.internal_convos
    this.contact=this.contactState;
    EventBus.$on("convoRef",(reference)=>{
      this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab;
      this.chatRef=reference[1]   
    }),
    EventBus.$on("createConvo", (message) => {
      this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab; 
      if(message) {
        if(message.text_message_id) {
          message.text_message = { date: message.date, direction: message.comm_direction, message: message.message, text_message_id: message.text_message_id, media_count : message.count };
        } else {
          message.call = { date: message.date, call_uuid: message.call_uuid, call_missed: message.call_missed, comm_ref: message.comm_ref };
        }
        let obj = {
          convo_references: [
            {
              conversation: {
                contact_id: this.contactState.contact_id,
                id: message.comm_participant_id,
                date: message.date,
                texts: message.text_message_id ? {...message.text_message,...message} : {},
                calls: message.call ? {...message.call,...message} : {}
              },
              conversation_id: message.comm_participant_id,
            },
          ]
        };
        this.selectedConvo = { ...obj };
        this.selectedMessage = message;
      } else {
        this.selectedConvo = { contact_id: this.contact.contact_id }
        this.selectedMessage = null;
      }
      this.selectedConvo.temporary = true;
      this.internalMessages = [];
    });
    EventBus.$on("showContactConvos", () => {
      this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab;
      this.selectedConvo = null;
      this.endHighlight();
      this.local_internalConvos = this.internal_convos_on_contact();
      this.convoListType = 'contact';
    });
    EventBus.$on("showCommConvos", (item) => {
      this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab;
      this.selectedConvo = null;
      this.endHighlight();
      this.local_internalConvos = this.internal_convos_on_comm(item?.comm_participant_id);
      this.convoListType = 'comm';
    });
    EventBus.$on("openlabconversation",(matchedConvo) => {
   this.openConvo(matchedConvo);
     this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab;
});
    EventBus.$on("populateRightPanel", async (_contact,convos) => {
      this.isfamily = false;
      this.contact = _contact;
      this.setInternalConvos=convos;
      this.convoListType = 'all';
      this.selectedConvo = null;
    });
    EventBus.$on("populateRightPanel1", () => {
      this.selectedConvo = null;
      this.set_right_panel_tab("internalConversations");
      this.tab = this.right_panel_tab;
        this.isfamily = false;
    });
    EventBus.$on("reference-not-found",()=>{
      this.seeReference = true;
    })
    EventBus.$on("closeinternallabdata",()=>{
     this.labcasesdata ={};
     this.showlabdata = false;});
     this.tab = this.right_panel_tab;
     this.setCurrent_process("internal");
  },
  beforeUnmount() {
    EventBus.$off("createConvo");
    EventBus.$off("showCommConvos");
    EventBus.$off("populateRightPanel");
    EventBus.$off("populateRightPanel1");
    EventBus.$off("convoRef");
    EventBus.$off("showContactConvos");
    EventBus.$off("reference-not-found");
     EventBus.$off("openlabconversation");
     EventBus.$off("closeinternallabdata");
    this.setCurrent_process(null);
    if(this.value == 1){
      this.getOpenedConvos();
    }
  },

  watch: {
    async contact() {
      if(!this.isfamily){
        this.convoListType = 'all';
            if (this.contact && this.contact.contact_id) {
        this.setInternalConvos = this.contact_internal_convo(this.contact.contact_id);
    } else {
      this.setInternalConvos = [];
    }
        this.selectedConvo = null;
      }
      this.value = 0;
    },
    "internalMessages.length" : function(){
      this.scrollToBottom();
    },
    "internal_convos" : function(newList){
      this.local_internalConvos = this.internal_convos;
      // The currently-open thread's own convo just closed/was removed
      // elsewhere (e.g. a reminder-only convo auto-closed when its reminder
      // was deleted) — deleteInternalConvo's mutation drops it from
      // internal_convos entirely, but selectedConvo is a separate local
      // snapshot that wouldn't otherwise notice. Fall back to the list
      // instead of continuing to show a thread that's no longer there.
      if (this.selectedConvo && this.selectedConvo.convo_id &&
          !newList.some(c => c.convo_id === this.selectedConvo.convo_id)) {
        this.closeConvo();
      }
    }
  },

  methods: {
    ...mapMutations("frontdesk", ["set_right_panel_tab","update_convo_count"]),
    ...mapMutations("convos",["setCurrent_process"]),
    ...mapMutations("convos",["setInternalConvos"]),
    ...mapMutations(['changeRightPanelStatus']),
    ...mapActions("frontdesk",["searchConversation"]),
    ...mapActions("convos", ["getInternalMessages"]),
    convoFocus(){
      if(this.chatRef.length!=0){
        this.chatRef.scrollIntoView({ behavior: 'smooth' , block: 'center' });
        this.chatRef.style.backgroundColor = "yellow"
        setTimeout(()=>{
          this.chatRef.style.backgroundColor = "#e8e4e4"
        },1000)
      }
    },
    getReferenceMessage(ref, currentIndex) {
      if (ref === null) return null;
      const referenceMessage = this.internalMessages.find((message, idx) => {
        if (message.convo_message_id === ref) {
          message.index = idx; // Ensure index is included in the reference message
          return true;
        }
        return false;
      });
      return referenceMessage ? { ...referenceMessage, index: referenceMessage.index } : null;
    },
    scrollToReference(refIndex) {
      const element = document.getElementById(`message-${refIndex}`);
      if (element) {
        element.style.backgroundColor = 'yellow';
        setTimeout(() => {
          element.style.backgroundColor = ''; // revert to original or default background color
        }, 1000);
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
       isValidLabDate(date) {
        if (!date) return false;
        const d = String(date).trim();
        // common invalid placeholders
        const invalidStarts = ["0001-01-01", "1900-01-01", "1901-01-01"];
        // also check pure zero or empty
        if (d === "0000-00-00" || d === "-" || d === "") return false;
        // if it starts with any invalid placeholder, treat as invalid
        if (invalidStarts.some(s => d.startsWith(s))) return false;
        return true;
      },
     displayDate(date) {
          if (!date) return "—"
          const invalids = ["1900-01-01", "1901-01-01", "0001-01-01"]
          if (invalids.some(d => date.startsWith(d))) {
            return "—"
          }
        
          return this.simpleDateFormat(date)
        },
    async openConvo(convo) {
      const ref0 = convo.convo_references?.[0];
      const { LabCaseNum } = ref0 ?? {};
      if (LabCaseNum) {
        this.loadingLabCase = true;
        try {
          const response = await odService.getlabcases(null, LabCaseNum);
          console.log("Lab case response:", response.data);
          if (response.data) {
            this.labcasesdata = response.data;
            this.showlabdata = true;
          } else {
            this.labcasesdata = {};
            this.showlabdata = false;
          }
        } catch (error) {
          this.labcasesdata = {};
          this.showlabdata = false;
          console.error("Error fetching lab case:", error);
        } finally {
          this.loadingLabCase = false;
        }
      } else {
        this.labcasesdata = {};
        this.showlabdata = false;
      }
      this.selectedConvo = convo;
      this.internalMessages = await this.getInternalMessages(convo.convo_id);
      this.scrollToBottom();
      this.highlightConvoComm(convo);
      this.seeReference = false;
      if (ref0?.conversation) {
        this.selectedMessage = {
          ...(ref0.conversation?.texts || ref0.conversation?.mails || ref0.conversation?.calls?.[0])
        };
        this.selectedMessage = {
          ...this.selectedMessage,
          contact_id: ref0.conversation.contact_id,
          comm_participant_id: ref0.conversation.id,
          date: this.selectedConversation.date
        };
      } else {
        this.selectedMessage = null;
      }
    },
    closeConvo() {
      this.showlabdata = false;
      this.selectedConvo = null;
      this.internalMessages = [];
    },
    async deleteConvo(convo){
      try {
        let convoId = convo.convo_id;
        let conversation_id = convo.convo_references[0].conversation_id;
        if(confirm("Are you sure you want to delete this conversation ?")){
          await ConvoService.updateConvoStatus(convoId, {status : false,process : 'internal'});
          this.closeConvo();
          this.setInternalConvos = this.internal_convos.filter((convo)=> convo.convo_id !== convoId );
          this.update_convo_count({"conversation_id": conversation_id, "count": -1});
        }
      } catch (error) {
        console.error(error);
        EventBus.$emit("alert", {
          message: "Failed To Close Conversation",
          type: "error-snack",
        });
      }
    },
    getReminder(participant_id) {
      if (!this.selectedConvo || !this.selectedConvo.convo_reminders.length) return false;
      let r = this.selectedConvo.convo_reminders.find((r) => r.reminder_for_who === participant_id);
      return r ? r : false;
    },
    goBackToAll() {
      this.setInternalConvos = this.contact_internal_convo(this.contact.contact_id);
      this.local_internalConvos = this.internal_convos;
      this.convoListType = 'all';
    },
    // create new internal convo
    async internalMessageSent(message) {
      
      let comm = this.selectedMessage ? this.selectedConvo?.convo_references[0]?.conversation_id : null;
      EventBus.$emit("submitConvo", message, comm);
      setTimeout(async () => {
        this.closeConvo();
        EventBus.$emit("update-InternalConvos", this.contact.contact_id);
      }, 500);
      ;
    },
    highlightConvoComm(convo) {
      
      if(this.convoHighlightTimeout)
        clearTimeout(this.convoHighlightTimeout);

      this.convoHighlightTimeout = setTimeout(() => {
        if(convo.convo_references[0].conversation_id)
          EventBus.$emit("highlightConvoComm", convo);
        else
          EventBus.$emit("highlightContact");
      }, 1500);
    },
    endHighlight() {
      if(this.convoHighlightTimeout)
        clearTimeout(this.convoHighlightTimeout);

      EventBus.$emit("clearHighlight");
    },
  
    checkContactID() {
      return (this.contact && this.contact.OD_PatNum);
    },
    checkIfCreate() {
      return !this.contact.contact_id;
    },
    scrollToBottom() {
      setTimeout(() => {
        if (this.$refs.scroller && this.internalMessages.length) {
          this.$refs.scroller.scrollToItem(this.internalMessages.length - 1);
        }
      }, 100);
    },
    getClosedConvos(){
      EventBus.$emit("update-InternalConvos", this.contact.contact_id, true);
    },
    getOpenedConvos(){
      EventBus.$emit("update-InternalConvos", this.contact.contact_id);
    },
    async getConversations(){
      this.seeReference = false;
      await this.searchConversation({timestamp : this.selectedConvo.convo_references[0].conversation.timestamp, contact_id :  this.selectedConvo.convo_references[0].contact_id });
      this.highlightConvoComm(this.selectedConvo);
    }
  },
};
</script>

<style scoped>

.outbound {
  background-color: #e3e3e3;
  align-items: flex-end;
  align-content: flex-end;
  align-self: flex-end;
}

.chat-bubble {
  text-align: left;
  font-size: 0.9rem;
  width: auto;
  max-width: 80%;
  padding: 10px;
  border-radius: 0.5rem;
}
.tab-container{
  width: 100%;
  height: 73vh;
  overflow-y: scroll;
}
.ref-button{
  position: relative;
  bottom: 25px;
  left : 5px;
}
.time {
  font-size: 0.6rem;
  text-align: right;
  color: #90a09f;
  flex-shrink: 0;
}
</style>
